var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1379 0.861949C15.3983 1.1223 15.3983 1.54441 15.1379 1.80476L7.80458 9.13809C7.54423 9.39844 7.12212 9.39844 6.86177 9.13809C6.60142 8.87774 6.60142 8.45563 6.86177 8.19528L14.1951 0.861949C14.4554 0.6016 14.8776 0.6016 15.1379 0.861949Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1379 0.861907C15.319 1.043 15.3803 1.31182 15.2957 1.55354L10.6291 14.8869C10.5388 15.1449 10.3001 15.3216 10.027 15.3328C9.7539 15.3439 9.50165 15.1872 9.39063 14.9374L6.8281 9.17171L1.06241 6.60919C0.812628 6.49817 0.655919 6.24592 0.667061 5.9728C0.678204 5.69968 0.85494 5.46104 1.11294 5.37074L14.4463 0.704072C14.688 0.619469 14.9568 0.680815 15.1379 0.861907ZM3.14056 6.07371L7.60393 8.05744C7.75475 8.12447 7.87535 8.24506 7.94238 8.39588L9.9261 12.8593L13.5799 2.41996L3.14056 6.07371Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.6e2e60b5837c073b2b63012df244dc73.svg";
export { ForwardRef as ReactComponent };